// Add a product row to article or blog post


let additions = [
    {
    "id":1,
    "article":"lucces-premium-lab-grown-diamonds",
    "collection":"petal-collection",
    "products":['fiore-diamond','ellia-round-diamond','azalea-round-diamond','lucia-halo-pave-diamond'],
    "location":"PETAL SIGNATURE™ LAB DIAMOND ENGAGEMENT RINGS",
    "direction":"after"
    },
    {
    "id":2,
    "article":"lucces-premium-lab-grown-diamonds",
    "collection":"bouquet-diamond-three-stone-rings",
    "products":['fiore-trio-diamond','fiore-trio-pear-diamond','sophia-pave-round-diamond','sophia-luxe-oval-diamond'],
    "location": "BOUQUET SIGNATURE™ LAB DIAMOND ENGAGEMENT RINGS",
    "direction":"after"
    },
    {
    "id":3,
    "article":"lucces-premium-lab-grown-diamonds",
    "collection":"roma-diamond",
    "products":['angela-diamond','angela-diamond','angela-luxe-diamond','montevalle-pave-diamond'],
    "location": "ROMA LAB-GROWN DIAMOND ENGAGEMENT RING COLLECTION",
    "direction":"after"
    },  
    {
    "id":4,
    "article":"lucces-premium-lab-grown-diamonds",
    "collection":"the-venezia-diamond-collection",
    "products":['firenze-pave-princess-diamond','alessa-diamond','montevalle-pave-pear-diamond','verona-oval-diamond'],
    "location": "VENEZIA LAB-GROWN DIAMOND ENGAGEMENT RING COLLECTION",
    "direction":"after"
    },    
    {
    "id":5,
    "article":"pink-lab-diamonds-for-engagement-rings",
    "collection":"rose-lab-diamond-collection",
    "products":['siena-pave-pear-rose','danna-rose-center-lab-diamond','azalea-oval-rose-lab-diamond-new','lucia-luxe-lab-diamond'],
    "location": "WHY CHOOSE A PINK LAB DIAMOND ENGAGEMENT RING",
    "direction":"before"
    },
    {
    "id":6,        
    "article":"platinum-engagement-rings",
    "collection":"petal-collection",
    "products":['fiore-diamond','ellia-round-diamond','azalea-round-diamond','lucia-halo-pave-diamond'],
    "location": "PLATINUM RINGS - A CANVAS OF BRILLIANCE FOR DIAMONDS",
    "direction":"before"
    },
    {
    "id":7,    
    "article":"platinum-engagement-rings",
    "collection":"bouquet-diamond-three-stone-rings",
    "products":['fiore-trio-diamond','fiore-trio-pear-diamond','sophia-pave-round-diamond','sophia-luxe-oval-diamond'],
    "location": "A LEGACY TO LAST A LIFETIME",
    "direction":"before"
    },
    {
    "id":8,        
    "article":"gold-engagement-rings",
    "collection":"petal-collection",
    "products":['fiore-diamond','ellia-round-diamond','azalea-diamond','lucia-halo-pave-diamond'],
    "location": "A SYMPHONY OF GOLD ENGAGEMENT RING STYLES FOR EVERY LOVE STORY",
    "direction":"before"
    },
    {
    "id":9,        
    "article":"gold-engagement-rings",
    "collection":"bouquet-diamond-three-stone-rings",
    "products":['fiore-trio-diamond','fiore-trio-pear-diamond-new','sophia-pave-diamond-new','sophia-luxe-oval-diamond-new'],
    "location": "LOVE THAT ENDURES, REFLECTED IN GOLD RINGS",
    "direction":"before"
    },
    {
    "id":10,        
    "article":"gold-engagement-rings",
    "collection":"roma-diamond",
    "products":['ronah-diamond','presa-diamond','miriam-pave-diamond','biella-diamond'],
    "location": "GOLD KARAT FOR ENGAGEMENT RINGS",
    "direction":"before"
    },
    {
    "id":11,        
    "article":"how-to-propose/guide-valentines-day-proposal",
    "collection":"bouquet-diamond-three-stone-rings",
    "products":['fiore-trio-diamond','fiore-trio-pear-diamond-new','sophia-pave-diamond-new','sophia-luxe-oval-diamond-new'],
    "location": "READY TO START PLANNING YOUR UNFORGETTABLE VALENTINE'S DAY",
    "direction":"before"
    },
    {
    "id":12,        
    "article":"platinum-engagement-rings",
    "collection":"roma-diamond",
    "products":['angela-diamond','angela-diamond','angela-luxe-diamond','montevalle-pave-diamond'],
    "location": "WHY PLATINUM ENGAGEMENT RINGS IS A SOUGHT-AFTER CHOICE",
    "direction":"before"
    },
      {
    "id":13,        
    "article":"how-to-propose/lab-diamond-engagement-ring-lucce-diamond-selector",
    "collection":"bouquet-lab-diamond-three-stone-rings",
    "products":['sophia-oval-lab-diamond-new','sophia-oval-luxe-lab-diamond-new','fiore-trio-lab-diamond','chesca-pear-lab-diamond-new'],
    "location": "BEYOND THE TREND: UNDERSTANDING THE 4CS",
    "direction":"before"
    },
   {
    "id":14,        
    "article":"how-to-propose/rise-lab-diamond-engagement-rings-philippines",
    "collection":"petal-collection",
    "products":['fiore-lab-diamond','ellia-round-lab-diamond','lucia-pave-lab-diamond','paula-oval-lab-diamond'],
    "location": "A SPARK OF CHANGE: EMBRACING TRANSPARENCY AND SUSTAINABILITY",
    "direction":"before"
    },
   {
    "id":15,        
    "article":"how-to-propose/5-reasons-lab-diamond-most-romantic-philippines",
    "collection":"bouquet-lab-diamond-three-stone-rings",
    "products":['sophia-oval-lab-diamond-new','sophia-oval-luxe-lab-diamond-new','fiore-trio-lab-diamond','chesca-pear-lab-diamond-new'],
    "location": "2. A SPARKLE BUILT ON TRUST",
    "direction":"before"
    },
    {
    "id":20,
    "article":"luxury-lifestyle-jewelry-collection",
    "collection":"the-carla-design",
    "products":['carla-tapered-bracelet-lab-diamond','carla-necklace-lab-diamond','carla-band-lab-diamond-new','carla-bracelet-lab-diamond'],
    "location": "THE CARLA DESIGN",
    "direction":"after"
    },
    {
    "id":21,
    "article":"luxury-lifestyle-jewelry-collection",
    "collection":"the-stella-design",
    "products":['stella-lab-diamond-bracelet','stella-necklace-lab-diamond','stella-earrings-lab-diamond-new','stella-stud-lavish™-lab-diamond'],
    "location": "THE STELLA DESIGN",
    "direction":"after"
    },
    {
    "id":22,
    "article":"luxury-lifestyle-jewelry-collection",
    "collection":"the-kaela-design",
    "products":['kaela-necklace-diamond','kaela-stud-diamond-new','kaela-pave-diamond-new','kaela-oval-necklace-diamond'],
    "location": "THE KAELA DESIGN",
    "direction":"after"
    },
    {
    "id":23,
    "article":"luxury-lifestyle-jewelry-collection",
    "collection":"the-montevalle-design",
    "products":['montevalle-rose-necklace-diamond','montevalle-bracelet-diamond-new','montevalle-earrings-diamond-new','montevalle-pave-diamond'],
    "location": "THE MONTEVALLE DESIGN",
    "direction":"after"
    },
    {
    "id":24,
    "article":"luxury-lifestyle-jewelry-collection",
    "collection":"the-fiore-design",
    "products":['fiore-iv-necklace','fiore-band-lab-diamond','fiore-rose-diamond','fiore-trio-oval-diamond-new'],
    "location": "THE FIORE DESIGN",
    "direction":"after"
    },
   {
    "id":25,
    "article":"lucces-premium-lab-grown-diamonds",
    "collection":"the-vogue-diamond-collection",
    "products":['christine-diamond','danielle-lab-diamond','jamila-diamond','sarah-diamond'],
    "location": "VOGUE LAB-GROWN DIAMOND ENGAGEMENT RING COLLECTION",
    "direction":"after"
    }, 
    {
    "id":26,
    "article":"luxury-lifestyle-jewelry-collection",
    "collection":"diamond-stud-earrings",
    "products":['maria-hoop-earrings-lab-diamond','trio-earrings-lab-diamond-new','theresa-earrings-lab-diamond','lyra-lab-diamond-stud'],
    "location": "EARRINGS COLLECTION",
    "direction":"after"
    },
    {
    "id":27,
    "article":"luxury-lifestyle-jewelry-collection",
    "collection":"diamond-necklace-collection",
    "products":['theresa-necklace-lab-diamond-new','trio-lab-diamond-necklace-new','personalized-letter-necklace-lab-diamond','the-emblem-lab-diamond-necklace-new'],
    "location": "NECKLACE COLLECTION",
    "direction":"after"
    },
    //example addition after another addition(collection)
    // {
    // "id":10,        
    // "article":"lucces-premium-lab-grown-diamonds",
    // "collection":"roma-lab-diamond",
    // "products":['ronah-lab-diamond','presa-lab-diamond','miriam-pave-lab-diamond','biella-lab-diamond'],
    // "location": 1,
    // "direction":"after"
    // },
]



let pg_url = window.location.href
let is_blog_pg = false


// additions.forEach(obj=>{
//     if(pg_url.includes('pages/' + obj["article"]) && pg_url.includes('pages/diamond-selection') == false){
//         addProductRow(obj)
//     } else if(pg_url.includes('blogs/' + obj["article"])){
//         is_blog_pg = true
//         addProductRow(obj)
//     }
// })

addProdRows()

async function addProdRows(){
    for(let i=0;i < additions.length;i++){
        if(pg_url.includes('pages/' + additions[i]["article"]) && pg_url.includes('pages/diamond-selection') == false){
            await addProductRow(additions[i])
        } else if(pg_url.includes('blogs/' + additions[i]["article"])){

            is_blog_pg = true
            await addProductRow(additions[i])
        }
    }
}





async function addProductRow(obj){
    let elements = Array.from(document.body.getElementsByTagName('*'))
    let ele
    let sibbling
    let product_section_preview_id = 'Customize-Product-Section-Preview-' + obj['id']

    if(Number.isInteger(obj['location'])){
        //location comes after another addition
        sibbling = document.getElementById('Customize-Product-Section-Preview-' + obj['location'])    
    }
    else{

        //search elements for location
        for(let x=0;x<elements.length;x++){
            let txt = elements[x].innerText
            if(txt && txt.includes(obj['location'])){
                if(is_blog_pg){
                    if(elements[x].parentElement.classList.contains('rte')){
                        sibbling = elements[x]
                    }
                    ele = elements[x].parentElement
                } else{
                    if(elements[x].parentElement.classList.contains('con_page_alt')){
                        sibbling = elements[x]
                    }
                    ele = elements[x]
                }
                
            }
        }
    }

    
    
    let product_html = ''
    for(let x=0; x < obj['products'].length;x++){

                let resp  = await fetch(window.Shopify.routes.root + 'products/'+ obj['products'][x] +'.js')
                let product = await resp.json()

                let last_img = product.images[product.images.length - 1]

                let white_img = product.variants.filter(variant=>variant['title'].includes('14K White Gold'))[0]['featured_image']['src']
                let yellow_img = product.variants.filter(variant=>variant['title'].includes('14K Yellow Gold'))[0]['featured_image']['src']
                let rose_img = product.variants.filter(variant=>variant['title'].includes('14K Rose Gold'))[0]['featured_image']['src']

                let product_price = '₱' + (product.price/100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })

                let li = `<li class="grid__item small--one-half medium-up--one-quarter" style="list-style:none;">
                <div class="grid-view-item{% unless product.available %} product-price--sold-out grid-view-item--sold-out{% endunless %} customize-no-select customize-mobile-margin-bot-35"> 
                
                
                <a style="border:none;" class="grid-view-item__link has-secondary" href="`+ product.url +`"> 
                    <img class="grid-view-item__image" src="`+ product.featured_image +`" data-src="`+ product.featured_image +`" alt="`+ product.handle +`"> 
                
                    <img class="merox-lazy secondary" src="`+ last_img + `" data-src="`+ last_img + `" alt="`+ product.handle +`"> 
                
                
                    <img id="Customize-GVI-Color-White-`+ product.id +`" class="customize-gvi-image-white" src="`+ white_img +`">
                    <img id="Customize-GVI-Color-Yellow-`+ product.id +`" class="customize-gvi-image-yellow" src="` + yellow_img + `">
                    <img id="Customize-GVI-Color-Rose-`+ product.id +`" class="customize-gvi-image-rose" src="`+ rose_img +`">
                
                
                <div class="customize-grid-view-item-color-selector-container">
                <div class="customize-grid-view-item-color-selector">
                    <div data-gviprodid="`+ product.id +`" onmouseover=holdLastGVIImage(event,this) onmouseout=holdLastGVIImageOut(event,this) class="customize-grid-view-item-color-selector-span-container">
                    
                    <span data-gviprodid="`+ product.id +`" data-gvicolor="White" onclick=clickChangeGVIImage(event,this) onmouseover=changeGVIImage(event,this) onmouseout=changeGVIImageOut(event,this)><span class="customize-gvi-color-white"><span class="customize-gvi-line"></span></span></span>
                    <span data-gviprodid="`+ product.id +`" data-gvicolor="Yellow" onclick=clickChangeGVIImage(event,this)  onmouseover=changeGVIImage(event,this) onmouseout=changeGVIImageOut(event,this) style="margin-left:-2px;"><span class="customize-gvi-color-yellow"><span class="customize-gvi-line"></span></span></span>
                    <span data-gviprodid="`+ product.id +`" data-gvicolor="Rose" onclick=clickChangeGVIImage(event,this)  onmouseover=changeGVIImage(event,this) onmouseout=changeGVIImageOut(event,this) style="margin-left:-2px;"><span class="customize-gvi-color-rose"><span class="customize-gvi-line"></span></span></span>
                    </div>
                </div>
                </div>
                
                
                    <div style="margin:0" class="h4 grid-view-item__title">`+ product.title +`</div> 
                    <div class="grid-view-item__meta">
                        <dl class="price price--listing">
                
                        <div class="price__regular">
                            <dt>
                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                            </dt>
                            <dd>
                            <span class="price-item price-item--regular">
                                
                                
                                <span class="money buckscc-money">`+product_price+`</span>
                            </span>
                            <div class="customize-theme-price-info">Setting Price only</div>
                            </dd>
                        </div>
                        <div class="price__sale">
                            <dt>
                            <span class="visually-hidden visually-hidden--inline">Sale price</span>
                            </dt>
                            <dd>
                            <span class="price-item price-item--sale"><span class="money buckscc-money">`+product_price+`/span>
                        </span>
                            <div class="customize-theme-price-info">Setting Price only</div>
                            </dd>
                            <div class="price__compare">
                            <dt>
                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                            </dt>
                            <dd>
                                <s class="price-item price-item--regular">
                                
                                </s>
                            </dd>
                            </div>
                        </div>
                        </dl>
                    </div> 
                </a> 
                </div> 
                
                
                </li>`
            
                product_html = product_html + li
    }
    

    let product_section_preview = document.createElement('div')
    product_section_preview.classList.add('shopify-section')
    product_section_preview.classList.add('index-section')

    product_section_preview.innerHTML = `<div id="`+ product_section_preview_id +`" class="page-width customize-pg-width">
    <ul class="grid grid--uniform grid--view-items customize-grid--view-items">`
    + product_html +
    `</ul>
    <div class="text-center">
    <a href="/collections/`+ obj['collection'] +`" class="btn customize-mobile-margin-bot-35" aria-label="View all products in the The Pink Lab Diamond Selection collection">
        View all
    </a>
    </div>
    </div>`

    document.body.append(product_section_preview)
    
    if(obj['direction'] == 'after'){

        insertAfter(sibbling,product_section_preview)
    } else{
        sibbling.parentNode.insertBefore(product_section_preview,sibbling)
    }

}


function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}


let last_images_x = []

function changeGVIImage(e,ele){
    let grid_view_item = ele.parentElement.parentElement.parentElement.parentElement
    
    Array.from(grid_view_item.querySelectorAll('img')).forEach(img=>img.style.display='none')
    
    let color = ele.dataset.gvicolor
    let prod_id = ele.dataset.gviprodid
    document.getElementById('Customize-GVI-Color-'+ color + '-' + prod_id).style.display = 'block'
    
    if (last_images_x.length > 20){
        last_images_x = []
    } 

    last_images_x.unshift({prod_id:prod_id,element:'Customize-GVI-Color-'+ color + '-' + prod_id})

}

function changeGVIImageOut(e,ele){
    let grid_view_item = ele.parentElement.parentElement.parentElement.parentElement
    
    Array.from(grid_view_item.querySelectorAll('img')).forEach(img=>img.style.display='')

}

function holdLastGVIImage(e,ele){
    let prod_id = ele.dataset.gviprodid
    let img = last_images_x.filter(img=>img.prod_id === prod_id)[0]
    let grid_view_item = ele.parentElement.parentElement.parentElement.parentElement
    
    if(img){
        Array.from(grid_view_item.querySelectorAll('img')).forEach(img=>img.style.display='none')

        document.getElementById(img['element']).style.display = 'block'

    }
 
}

function holdLastGVIImageOut(e,ele){
    let grid_view_item = ele.parentElement.parentElement.parentElement.parentElement
    
    Array.from(grid_view_item.querySelectorAll('img')).forEach(img=>img.style.display='')
 
}



function clickChangeGVIImage(e,ele){
    let grid_view_item = ele.parentElement.parentElement.parentElement.parentElement
    
    Array.from(grid_view_item.querySelectorAll('img')).forEach(img=>img.style.display='none')
    
    let color = ele.dataset.gvicolor
    let prod_id = ele.dataset.gviprodid
    document.getElementById('Customize-GVI-Color-'+ color + '-' + prod_id).style.display = 'block'
    
    if (last_images_x.length > 20){
        last_images_x = []
    } 

    last_images_x.unshift({prod_id:prod_id,element:'Customize-GVI-Color-'+ color + '-' + prod_id})
   
    e.preventDefault()
}








